import React, { useEffect, useState } from "react";
import {useDispatch, useSelector} from "react-redux";
import {toggleModal} from "../../store/actions/toggleModalActions";
import {isCompanyAdmin, isCustomer, isDistributorAdmin, isSuperAdmin} from "../../helpers/helpers";
import {
    getGateSwitchers,
    getGateSwitchersAlertRules, selectGateSwitcher,
    setGateSwitchersFilters
} from "../../store/actions/gateSwitchersActions";
import Spinner from "../_common/Spinner";
import List from "../_common/List";
import {getDrainStations, selectDrainStation} from "../../store/actions/drainStationsActions";
import GateSwitcherModal from "./GateSwitcherModal";
import DetailsModal from "../_common/DetailsModal";
import DrainStationDetails from "../DrainStations/DrainStationsDetails";
import GateSwitchersDetails from "./GateSwitchersDetails";

const selector = state => {
    const { language, gateSwitchers, modalState, fields, users } = state;
    return {
        t: language.translator,
        pending: gateSwitchers.pending,
        gateSwitchers: gateSwitchers.gateSwitchers,
        page: gateSwitchers.page,
        pageCount: gateSwitchers.pageCount,
        itemsCount: gateSwitchers.itemsCount,
        selected: gateSwitchers.selected,
        filters: gateSwitchers.filters,
        modalState: modalState,
        fields: fields.fields,
        filteredUser: users.filtered,
    }
};

const GateSwitchers = props => {
    const { t, pending, gateSwitchers, page, pageCount, itemsCount, modalState, selected, filters, fields, filteredUser } = useSelector(selector)
    const dispatch = useDispatch();

    const [filter, setFilter] = useState('ALL');
    const [search, setSearch] = useState('');
    const [itemsPerPage, setItemsPerPage] = useState(10);

    useEffect(() => {
        if(isCompanyAdmin() || isSuperAdmin() || isDistributorAdmin()) {
            // dispatch(filterUser({}));
            dispatch(getGateSwitchers(1, itemsPerPage, filter, '', ''));
        } else {
            dispatch(getGateSwitchers(1, itemsPerPage, filter, '', ''));
        }

        dispatch(getGateSwitchersAlertRules())
    }, []);

    const closeModal = () => {
        dispatch(toggleModal(false, ''))
    };

    return (
        <div className="communitySensors">
            <form className='sensorFilter stationFilter'>
                <div className='searchInputWrapper'>
                    <input
                        type='text'
                        className='sensorSearchInput'
                        placeholder={t.gettext('Search')}
                        value={search}
                        onChange={e => setSearch(e.target.value)}
                    />
                    {filters.search
                        ? <span
                            className='material-icons sensorSearchCancelButton'
                            onClick={() => {
                                dispatch(setGateSwitchersFilters({active: filter, itemsPerPage, search: ''}))
                                setSearch('');
                                dispatch(getGateSwitchers(1, itemsPerPage, ''));
                            }}
                        >
                            cancel
                        </span>
                        : null
                    }
                </div>
                <button
                    className='sensorSearchButton'
                    onClick={e => {
                        e.preventDefault();
                        dispatch(setGateSwitchersFilters({active: filter, itemsPerPage, search}))
                        dispatch(getGateSwitchers(1, itemsPerPage, search));
                    }}
                    disabled={!search}
                >
                    {t.gettext('SEARCH')}
                </button>
                <label htmlFor='itemsPerPage' className={'itemsPerPageLabel'}>
                    {t.gettext('Items per page')}
                </label>
                <input
                    type='number'
                    id='itemsPerPage'
                    className='sensorSearchInput itemsPerPageInput'
                    min={1}
                    step={1}
                    defaultValue={itemsPerPage}
                    onChange={e => {
                        e.preventDefault();
                        if (e.target.value) {
                            setItemsPerPage(e.target.value < 1 ? 1 : e.target.value);
                            dispatch(setGateSwitchersFilters({
                                active: filter,
                                itemsPerPage: e.target.value < 1 ? 1 : e.target.value,
                                search: filters.search
                            }));
                            dispatch(getGateSwitchers(1, e.target.value < 1 ? 1 : e.target.value, filter, filteredUser.id ? filteredUser.id : '', filters.search));
                        }
                    }}
                />
                <div className="addStationWrapper">
                    <div className="addStationBtn" onClick={() => dispatch(toggleModal(true, 'Add Gate Switcher'))}>
                        {t.gettext('Add Gate Switcher')}
                    </div>
                </div>
            </form>
            <div className={'sensorList sensorList--expanded'}>
                {pending
                    ? <div className='page'>
                        <Spinner size={300}/>
                    </div>
                    : <List
                        roundTopCorners
                        items={gateSwitchers}
                        page={page}
                        itemsPerPage={itemsPerPage}
                        pageCount={pageCount}
                        itemsCount={itemsCount}
                        columnsNames={isCustomer() ?  ['Name', 'Temp Close', 'Temp Open', 'Enabled'] :  ['User Name', 'Name', 'Temp Close', 'Temp Open', 'Enabled'] }
                        columns={isCustomer() ?  ['setName', 'tempClose', 'tempOpen', 'enabled'] : ['userName', 'setName', 'tempClose', 'tempOpen', 'enabled']}
                        columnsWidths={isCustomer() ?  ['25%', '25%', '25%', '25%'] : ['20%', '20%', '20%', '20%', '20%']}
                        filter={filter}
                        booleanColumn={isCustomer() ?  4 : 5}
                        getItemsMethod={getGateSwitchers}
                        selectItemMethod={selectGateSwitcher}
                        onSelectModalName={'Gate Switcher Details'}
                        userId={filteredUser.id ? filteredUser.id : ''}
                        search={filters.search}
                    />
                }
                {(modalState.flag && modalState.modal === 'Add Gate Switcher') && (
                        <GateSwitcherModal />
                )}
                {(modalState.flag && modalState.modal === 'Gate Switcher Details') &&
                <DetailsModal
                    closeMethod={closeModal}
                >
                    <GateSwitchersDetails
                        gateSwitcher={selected.gateSwitcher}
                    />
                </DetailsModal>
            }
            </div>
        </div>
    )
}

export default GateSwitchers
